import { Editor } from "@tinymce/tinymce-react";
import { ContainerStyled } from "./styles/EditorTiny";

const EditorTiny = ({
  setValue,
  onEditorChange = (newValue) => {
    setValue(newValue);
  },
  ...props
}) => {
  return (
    <>
      <ContainerStyled>
        <Editor
          {...props}
          onEditorChange={onEditorChange}
          apiKey="21om7nyoc2d3oenuo3kn9rrvjcflei8xp641qqlfxm3jlofl"
          init={{
            selector: "textarea#local-upload",
            plugins: [
              " lists advlist autolink link autoresize image charmap print preview anchor autoresize ",
              " searchreplace visualblocks code fullscreen emoticons ",
              " insertdatetime media table paste code help wordcount ",
            ],
            toolbar:
              "formatselect | " +
              "bold italic backcolor | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat | help",
            content_style:
              "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
            language: "pt_BR",
            image_title: true,
            automatic_uploads: true,
            images_upload_handler: function (blobInfo, success, failure) {
              setTimeout(function () {
                success(`data:image/png;base64,${blobInfo.base64()}`);
              }, 2000);
            },
          }}
        />
      </ContainerStyled>
    </>
  );
};

export default EditorTiny;
